module.exports = __webpack_public_path__ + "static/img/5936_phase_function_Paper_Points.117f98d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5936_phase_function_Paper_Points.png
// module id = AabQ
// module chunks = 0